import { useEffect, useMemo, useState } from "react";
import {
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    useReactTable,
    getSortedRowModel,
} from "@tanstack/react-table";
import { ContainerTables, TableMobile, TableReq } from "./styled.components";
import Pagination from "@mui/material/Pagination";
import { Accordion, AccordionDetails, AccordionSummary, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ItemContainer, LabelItem, ValueItem } from "./styled.components";
import Grid from '@mui/material/Unstable_Grid2'
import ITable from "Interfaces/ITable";




const Table = ({ IColumns, IData, simply, notPagination }: ITable) => {
    const columns = useMemo(() => IColumns, []);
    const data = useMemo(() => IData, [IData]);
    const [globalFilter, setGlobalFilter] = useState("");
    const [sorting, setSorting] = useState<any>([]);

    const [expanded, setExpanded] = useState<string>('');
    const toggleAcordion = (panel: string) => setExpanded(expanded === panel ? '' : panel);


    const table = useReactTable({
        state: {
            sorting,
            globalFilter,
        },
        data,
        columns,
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
    });

    const handleChange = (event: any, value: any) => {
        table.setPageIndex(value - 1);
    };

    return (
        <div>
            {!simply
                ? <TextField
                    label="Buscador"
                    sx={{ m: 1, width: "25ch" }}
                    size="small"
                    value={globalFilter ?? ""}
                    onChange={(value) => setGlobalFilter(value.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                : ""}

            <ContainerTables>
                <TableReq>
                    <thead>
                        {table.getHeaderGroups().map((headerGroup:any) => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header:any) => (
                                    <th key={header.id}>
                                        <div
                                            {...{
                                                className: header.column.getCanSort()
                                                    ? 'cursor-pointer select-none'
                                                    : '',
                                                onClick: header.column.getToggleSortingHandler(),
                                            }}
                                            style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}
                                        >
                                            {flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )}
                                            {{
                                                asc: <FiChevronUp color="#00B3B0" />,
                                                desc: <FiChevronDown color="#00B3B0" />,
                                            }[header.column.getIsSorted() as string] ?? null}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.map((row:any) => (
                            <tr key={row.id}>
                                {row.getVisibleCells().map((cell:any) => (
                                    <td key={cell.id}>
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </TableReq>
                <TableMobile>
                    {table.getRowModel().rows.map((row: any, indexP: number) => {
                        return (
                            <Accordion
                                expanded={expanded === `panel${indexP}`}
                                key={row.id} >
                                <AccordionSummary
                                    expandIcon={<IconButton onClick={() => toggleAcordion(`panel${indexP}`)} ><ExpandMoreIcon /></IconButton>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                        {row.getVisibleCells().filter((cell:any) => cell.column.columnDef.className === 'title').map((cell:any, index:number) => (
                                            <Typography key={index}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </Typography>
                                        ))}
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2}>
                                        {row.getVisibleCells().filter((cell:any) => cell.column.columnDef.className !== 'title').map((cell:any, index:number) => (
                                            <Grid key={index} xs={12} sm={6}>
                                                <ItemContainer >
                                                    <LabelItem>{cell.column.columnDef.header()}</LabelItem>
                                                    <ValueItem wrap>{flexRender(cell.column.columnDef.cell, cell.getContext())}</ValueItem>
                                                </ItemContainer>
                                            </Grid>

                                        ))}
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        )

                    }

                    )}
                </TableMobile>
            </ContainerTables>

            {notPagination ||
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Pagination
                        count={table.getPageCount()}
                        page={table.getState().pagination.pageIndex + 1}
                        showFirstButton
                        showLastButton
                        onChange={handleChange}
                    />
                </div>

            }

        </div>
    );
};

export default Table;

